export default __webpack_public_path__ + "static/media/html.f3aa7827.png";